export default __webpack_public_path__ + "static/media/features_icon_1.28614743.svg";